import React from "react"

const QuoteButton = ({ 
  buttonText = "Get a Free Quote",
  buttonLink = "/contact",
  className = ""
}) => {
  return (
    <div className="about">
      <div className="content">
        <a 
          href={buttonLink} 
          className={`btn-schedule-call m-0 mb-4 ${className}`}
        >
          {buttonText}
        </a>
      </div>
    </div>
  )
}

export default QuoteButton 